import { defaults, deepDefaults } from '../utils/general-utils';

export class Scope<T extends Record<string, any>> {
  private readonly data: T | undefined;
  private static readonly KEYS_TO_DEEP_DEFAULTS = ['tags', 'context'];

  constructor(data: T | undefined) {
    this.data = data;
  }

  private getEntriesToDeepDefaults(data: T | undefined): T | undefined {
    if (!data) {
      return undefined;
    }
    return Object.fromEntries(
      Object.entries(data).filter(([key]) =>
        Scope.KEYS_TO_DEEP_DEFAULTS.includes(key),
      ),
    ) as unknown as T;
  }

  addDataScope(data: T | undefined | (T | undefined)[]): Scope<T> {
    const outerDataArray = Array.isArray(data) ? data : [data];
    const deepDefaultData = deepDefaults(
      ...outerDataArray.map((_data) => this.getEntriesToDeepDefaults(_data)),
      this.getEntriesToDeepDefaults(this.data),
    );
    return new Scope(defaults(deepDefaultData, ...outerDataArray, this.data));
  }

  getData() {
    return this.data;
  }
}
